import { ChatDots } from "react-bootstrap-icons";

const Footer = () => {
  const feedbackLink =
    "https://forms.office.com/Pages/ResponsePage.aspx?id=MLvwYuo3E0OE214hAn3hUzwH_vI8hVFAv3vIWrFk8aVUNEVEQzNXMTdRUE5TR1VNVUpNSkdKRVdFUy4u";

  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="copyright">
          &copy; {new Date().getFullYear()} The Green Energy Advice Bureau
        </p>
        <div className="footer-links">
          <a href={feedbackLink} target="_blank" className="footer-link" rel="noreferrer">
            <ChatDots />
            Submit a Request
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
